<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Yg1Jmw/tc-custom/9781328849878.jpg?1731155995604" alt="This image is the cover for the book Chumps To Champs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chumps To Champs
      </h1>
      <p class="bookDescription body article font2">
        <b>The untold story of the years when the Yankees were a laughingstock—and how out of that abyss emerged the modern Yankees dynasty, one of the greatest in all of sports</b><br/><br/> The New York Yankees have won 27 world championships and 40 American League pennants, both world records. They have 26 members in the Hall of Fame. Their pinstripe swag is a symbol of “making it” worn across the globe. Yet some 25 years ago, from 1989 to 1992, the Yankees were a pitiful team at the bottom of the standings, sitting on a 14-year World Series drought and a 35 percent drop in attendance. To make the statistics worse, their mercurial, bombastic owner was banned from baseball.<br/><br/> But out of these ashes emerged a modern Yankees dynasty, a juggernaut built on the sly, a brilliant mix of personalities, talent, and ambition. In <i>Chumps to Champs</i>, Bill Pennington reveals a grand tale of revival. Readers encounter larger-than-life characters like George Steinbrenner and unexplored figures like Buck Showalter (three-time manager of the year), Don Mattingly, and the crafty architect of it all, general manager Gene Michael, who assembled the team’s future stars—Rivera, Jeter, Williams, O’Neill, and Pettitte. <br/><br/> Drawing on unique access, Pennington tells a wild and raucous tale.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bill Pennington
      </h2>
      
      <p class="authorDescription body article">BILL PENNINGTON is an award-winning sportswriter for the <I>New York Times</I> and the author of <I>Billy Martin, On Par</I>, and <I>The Heisman</I>. A former syndicated columnist, Pennington was also a beat writer for the New York Yankees. A fifteen-time finalist&#160;and seven-time winner of the Associated Press Sports Editors&rsquo; annual writing award, Pennington lives with his family in Warwick, New York.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12bdce4e